// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","authCard":"Card_authCard__LP2yN"};